import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=bd408478&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Crumbs: require('/var/www/components/crumbs/crumbs.vue').default,CatalogFavorites: require('/var/www/components/catalog/catalog-favorites.vue').default,Baner: require('/var/www/components/baner/baner.vue').default})
